import { render, staticRenderFns } from "./ViewSurveyResult.vue?vue&type=template&id=2d87591d"
import script from "./ViewSurveyResult.vue?vue&type=script&lang=ts"
export * from "./ViewSurveyResult.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports